module.exports = __webpack_public_path__ + "img/wordmark-dark.babe8256.svg";